import axios from '@utils/axiosInstance'

const BASE = process.env.VUE_APP_BACKEND_PUBLIC_URL

const getDefaultState = () => {
  return {}
}

export const state = getDefaultState()

export const getters = {}

export const mutations = {
  RESET_CONVERSION_MANAGER_STATE(state) {
    Object.assign(state, getDefaultState())
  },
}

export const actions = {
  // NEW CONVERSION
  // POST
  async startConversionProcess(store, payload) {
    const url = `${BASE}/mx/api/v2/contractManager/conversion.startProcess`
    try {
      return await axios.post(url, payload)
    } catch (e) {
      throw Error(`API Error occurred at ${url}.`)
    }
  },
}
